import { useQuery } from 'react-query';
import styled from 'styled-components';
import { BenefitCardlet } from 'src/components';
import BenefitsService from 'src/services/BenefitsService';
import { BenefitId } from 'src/models/Benefit/Benefit';
import { arrayOfNumbers } from 'src/utils/array';

const Header = styled.h2`
  font-size: 24px;
  line-height: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 24px 0 0 0;
`;

const Item = styled.li`
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

const OtherBenefits: React.FC<{
  benefitId: BenefitId;
  limit?: number;
}> = ({
  benefitId,
  limit = 7,
}) => {
  const { data: benefits = [], isLoading } = useQuery(
    ['BenefitsLibrary'],
    () => BenefitsService.getMany(),
    { staleTime: Infinity },
  );

  const items = benefits
    .filter((benefit) => benefit.id !== benefitId)
    .slice(0, limit);

  const actualItemCount = isLoading ? null : items.length;
  const displayItemCount = actualItemCount ?? limit;

  if (!isLoading && items.length === 0) {
    return null;
  }

  return (
    <>
      <Header>Inne benefity</Header>
      <List>
        {arrayOfNumbers(displayItemCount).map((index) => (
          <Item key={items[index]?.id ?? index}>
            <BenefitCardlet benefit={items[index]} />
          </Item>
        ))}
      </List>
    </>
  );
};

export default OtherBenefits;
